const fontawesome =
`# Fontawesome icons

Hello World! :fa-camera:

- [:fa-google: Google](https://www.google.com/)
- [:fa-github: GitHub](https://github.com/)

See: [http://fontawesome.io/](http://fontawesome.io/) for more icons.
`
export {fontawesome}



// WEBPACK FOOTER //
// ./src/boilerplates/fontawesome.js